import React from 'react';
import './UsanaAuthError.css';

const UsanaAuthError = () => {
    const handleRedirectToUsana = () => {
        window.open('https://oolalife.com/products/oola-lifestyle-framework?ref=corporphan', '_blank');
    };

    return (
        <div className="usana-auth-error__container">
            <section className="usana-auth-error__content">
                <div className="usana-auth-error__card">
                    <div className="usana-auth-error__icon">
                        <svg
                            width="64"
                            height="64"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                            <path
                                d="M12 8V12M12 16H12.01"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                    <h1 className="usana-auth-error__title">
                        We're sorry, there was a problem trying to sign in to the program.
                    </h1>
                    <p className="usana-auth-error__description">
                        Please try again or contact support if the problem persists.
                    </p>
                    <button
                        type="button"
                        className="usana-auth-error__button"
                        onClick={handleRedirectToUsana}
                    >
                        Visit USANA Store
                    </button>
                </div>
            </section>
        </div>
    );
};

export default UsanaAuthError;
